import { Outlet } from "@tanstack/react-router";

/**
 * No persistent chrome here, matching apps/app's __root.tsx: the sign-in screen
 * (AuthFormView, from @secure-vault/ui) owns the full viewport, same as the
 * advisor app's /signin. Authenticated screens (dashboard) render their own
 * header instead of a global one.
 */
export function RootLayout() {
  return <Outlet />;
}
